// How the pipeline is ORDERED, apart from how it is filtered. Its own module so the
// rules can be tested without mounting the screen: which lead floats and why is the
// kind of thing that looks right on a short list and is wrong on a long one.
import he from '../../i18n/he';
import { topUrgency } from '../../components/UrgencyBadge';
import { openTasks as openOnly } from '../../components/TaskList';

// The sortable columns of a lead card, in the order they appear on it. Fed to
// useTableSort exactly as a table's columns are — the hook only ever asks a column
// what a row is worth — so the pipeline and the clients table share one comparator
// (Hebrew collation, numbers numerically, blanks last in both directions) rather than
// growing a second one. Labels are reused from the screens that already name these
// fields; stage is deliberately absent, since every card in a section shares it.
export const SORT_COLUMNS = [
  { key: 'name', label: he.clients.name, sortValue: (g) => g.client.name },
  // The card shows "contact · phone" as one line, so the column sorts by the contact
  // and falls back to the phone for a lead that has only a number.
  { key: 'contact', label: he.clients.contact, sortValue: (g) => g.client.contact_name || g.client.phone },
  { key: 'owner', label: he.leads.owner, sortValue: (g) => g.lead.owner_name },
  // By WHEN the next step is due, not by its text: the question this column answers is
  // who needs chasing soonest. The server hands open tasks over in due-date order, so
  // the first one is the next step. A lead with no next step has no date and lands at
  // the bottom, which is where "nothing scheduled" belongs.
  { key: 'next', label: he.leads.nextStep, sortValue: (g) => openOnly(g.tasks)[0]?.due_date },
];

// The same rule the urgent badge on the card is drawn from — OPEN tasks only, because
// a finished urgent task is not work that is still burning. If the two ever disagreed,
// a lead would sit at the top of its section wearing no badge to explain why.
export const isUrgent = (g) => topUrgency(openOnly(g.tasks)) === 'urgent';

// Stable partition, not a sort key: urgent leads keep whatever order the chosen column
// gave them, and so does everything below. That is what lets the pin sit ON TOP of any
// sort instead of competing with it.
export const urgentFirst = (items) => [...items.filter(isUrgent), ...items.filter((g) => !isUrgent(g))];
